import axios from "axios";
import jwt_decode from "jwt-decode";
import CryptoJS from "crypto-js";

import cookie from "vue-cookie";
import Vue from 'vue'
let refreshTokenTimer = null;
let refreshTokenRequest = null;
let lastRefreshTokenTime = 0;
const refreshBeforeSeconds = 30;
const minRefreshDelayMs = 10000;
const refreshThrottleMs = 15000;

export const state = {  
  JWToken: cookie.get("ecampus"),
  RefreshToken: cookie.get("ecampusRefreshToken"),
  AuthInfo: null,
};

export const getters = {
  isAuth() {
    if (cookie.get("ecampus")) {
      return true;
    } else {
      return false;
    }
  },
  RefreshToken() {
    if (cookie.get("ecampusRefreshToken")) {
      return CryptoJS.AES.decrypt(
        cookie.get("ecampusRefreshToken"),
        process.env.VUE_APP_SHA_KEY
      ).toString(CryptoJS.enc.Utf8);
    }
  },
  JWToken() {
    if (cookie.get("ecampus")) {
      return CryptoJS.AES.decrypt(
        cookie.get("ecampus"),
        process.env.VUE_APP_SHA_KEY
      ).toString(CryptoJS.enc.Utf8);
    }
  }, 
 
 
  
  UserNameSurName(){
    let token=CryptoJS.AES.decrypt(window.$cookies.get('ecampus'), process.env.VUE_APP_SHA_KEY).toString(CryptoJS.enc.Utf8)
    let decodetoken = jwt_decode(token)
    return decodetoken.given_name + " " + decodetoken.family_name
},
UserFirsName(){
  let token=CryptoJS.AES.decrypt(window.$cookies.get('ecampus'), process.env.VUE_APP_SHA_KEY).toString(CryptoJS.enc.Utf8)
  let decodetoken = jwt_decode(token)
  return decodetoken.given_name 
},
UserLastName(){
  let token=CryptoJS.AES.decrypt(window.$cookies.get('ecampus'), process.env.VUE_APP_SHA_KEY).toString(CryptoJS.enc.Utf8)
  let decodetoken = jwt_decode(token)
  return decodetoken.family_name
},
UserEmail(){
  let token=CryptoJS.AES.decrypt(window.$cookies.get('ecampus'), process.env.VUE_APP_SHA_KEY).toString(CryptoJS.enc.Utf8)
  let decodetoken = jwt_decode(token)
  return decodetoken.email
},
AvatarUrl() {
  let token = CryptoJS.AES.decrypt(
    window.$cookies.get("ecampus"),
    process.env.VUE_APP_SHA_KEY
  ).toString(CryptoJS.enc.Utf8);
  return jwt_decode(token).avatar;
},
  UserRolles(){
      let token=CryptoJS.AES.decrypt(window.$cookies.get('ecampus'), process.env.VUE_APP_SHA_KEY).toString(CryptoJS.enc.Utf8)
      var roles = jwt_decode(token).roles
      if(roles){
       if(roles.constructor.name == "Array"){
        return jwt_decode(token).roles
       }else{
        var role = []
        role.push(jwt_decode(token).roles);
        return role
       } }else{
        return []
      }
  },  
};

export const mutations = {
  SetJWToken(state, JWToken) {
    var decoded = jwt_decode(JWToken).exp;
    decoded = new Date(decoded * 1000);
    let cookieDomain = Vue.prototype.$config.COOKIES_DOMAIN == "localhost" ? null : Vue.prototype.$config.COOKIES_DOMAIN;
    //decoded.setHours( decoded.getHours() + 3 )
    let tokensifreleme = CryptoJS.AES.encrypt(
      JWToken,
      process.env.VUE_APP_SHA_KEY
    ).toString();
    window.$cookies.set(
      "ecampus",
      tokensifreleme,
      decoded,
      null,
      cookieDomain
    );
    state.JWToken = tokensifreleme;
    axios.defaults.headers.common = { 'Authorization': 'Bearer '+JWToken }
  },
  SetRefreshToken(state, RefreshToken) {
    if(!RefreshToken) return;
    let cookieDomain = Vue.prototype.$config.COOKIES_DOMAIN == "localhost" ? null : Vue.prototype.$config.COOKIES_DOMAIN;
    let tokensifreleme = CryptoJS.AES.encrypt(
      RefreshToken,
      process.env.VUE_APP_SHA_KEY
    ).toString();
    let decoded = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
    window.$cookies.set(
      "ecampusRefreshToken",
      tokensifreleme,
      decoded,
      null,
      cookieDomain
    );
    state.RefreshToken = tokensifreleme;
  },
  SetAuth(state, Auth) {
    state.AuthInfo = Auth;
  },
  ClearJWToken(state) {
    if(refreshTokenTimer) clearTimeout(refreshTokenTimer);
    refreshTokenTimer = null;
    refreshTokenRequest = null;
    window.$cookies.remove("ecampus",null,Vue.prototype.$config.COOKIES_DOMAIN);
    window.$cookies.remove("ecampus");
    window.$cookies.remove("ecampusRefreshToken",null,Vue.prototype.$config.COOKIES_DOMAIN);
    window.$cookies.remove("ecampusRefreshToken");
    state.JWToken = null; 
    state.RefreshToken = null;
    axios.defaults.headers.common = {}
  },
  ClearAuth(state) {
    state.AuthInfo = null;
  },
 
};

export const actions = {
 
  ActionsLogin(_, Data) {
    return axios
      .post(Vue.prototype.$config.API_ACCOUNT_URL + "Account/authenticate", Data)
      .then((res) => {

        if (res.data.Succeeded == true) {

          //commit("SetJWToken", res.data.Data.JWToken);
          //commit("SetAuth", res.data.Data);
          
          return res;
        } else {
          return res;
        }
      })
      .catch((error) => error.response.data)
      .catch((error) => {
        console.log(JSON.parse(JSON.stringify(error.response.data.errors)));
      });
  },

  ResetPasswordLogin(_, Data) { 
    return axios
      .post(Vue.prototype.$config.API_ACCOUNT_URL + "Account/reset-password", Data)
      .then((res) => {
        
          return res.data
      })
      .catch((error) => error.response.data)
      .catch((error) => {
        console.log(JSON.parse(JSON.stringify(error.response.data.errors)));
      });
  },

  UserUpdateLogin(_, Data) { 
    return axios
      .put(Vue.prototype.$config.API_ACCOUNT_URL + "Account/update", Data)
      .then((res) => {
        
          return res.data
      })
      .catch((error) => error.response.data)
      .catch((error) => {
        console.log(JSON.parse(JSON.stringify(error.response.data.errors)));
      });
  },
  
  ActionsLoginSessionKey({ commit }, Data) {  
    return axios
      .post(Vue.prototype.$config.API_ACCOUNT_URL + "Account/authenticate", Data)
      .then((res) => { 
        console.log(res);
        if (res.data.Succeeded == true) {
          commit("SetJWToken", res.data.Data.JWToken);
          commit("SetRefreshToken", res.data.Data.RefreshToken);
          commit("SetAuth", res.data.Data);
          return true;
        } else {
          return false; 
        }
      })
      .catch((error) => error.response.data)
      .catch((error) => {
        console.log(JSON.parse(JSON.stringify(error.response.data.errors)));
      });
  },

  ActionsLoginManisa({ commit }, Data) {  
          commit("SetJWToken", Data.JWToken);
          commit("SetRefreshToken", Data.RefreshToken);
          commit("SetAuth", Data.Data);
          return true;
  },

  logOut({ commit }) {
    commit("ClearJWToken");
    commit("ClearAuth"); 
    window.location.href = "/login";
  },

  TokenRefreshZamanKontrol({ dispatch, getters }) {
    if(!getters.JWToken) return;
    var decoded = jwt_decode(getters.JWToken);
    decoded = new Date(decoded.exp * 1000);
    let diffTime = decoded.valueOf() - new Date().valueOf();
    var kalanzaman = Math.floor(diffTime / 1000);
    if (kalanzaman <= refreshBeforeSeconds && 0 < kalanzaman) {
      dispatch("ActionsRefreshToken");
    }
  },

  ActionsRefreshToken({ commit, dispatch, getters }) {
    if(refreshTokenRequest) return refreshTokenRequest;
    if(new Date().valueOf() - lastRefreshTokenTime < refreshThrottleMs) {
      dispatch("CookiesZamanKontrol", minRefreshDelayMs);
      return Promise.resolve(false);
    }
    if(!getters.RefreshToken) {
      dispatch("logOut");
      return Promise.resolve(false);
    }
    lastRefreshTokenTime = new Date().valueOf();
    let Data = { RefreshToken: getters.RefreshToken };
    refreshTokenRequest = axios
      .post(Vue.prototype.$config.API_ACCOUNT_URL + "Account/refresh-token", Data)
      .then((res) => {
        if (res.data.Succeeded == true) {
          commit("SetJWToken", res.data.Data.Token);  
          if (res.data.Data.RefreshToken) {
            commit("SetRefreshToken", res.data.Data.RefreshToken);
          }
          dispatch("TokenZamaniHesaplama"); 
        }
        return res;
      })
      .catch((error) => error.response.data)
      .catch((error) => {
        console.log(JSON.parse(JSON.stringify(error.response.data.errors)));
      })
      .finally(() => {
        refreshTokenRequest = null;
      });
    return refreshTokenRequest;
  },
  TokenZamaniHesaplama({  dispatch,getters }) {
    if(!getters.JWToken)return;
    else{
        var decoded = jwt_decode(getters.JWToken);
        decoded = new Date(decoded.exp * 1000); 
        let diffTime = decoded.valueOf() - new Date().valueOf();
        var kalanzaman = Math.floor(diffTime / 1000);
        if(kalanzaman <= 0) {
          dispatch("ActionsRefreshToken");
          return;
        }
        kalanzaman = kalanzaman > refreshBeforeSeconds
          ? (kalanzaman - refreshBeforeSeconds) * 1000
          : Math.max(Math.floor(kalanzaman * 500), minRefreshDelayMs);
        dispatch("CookiesZamanKontrol", kalanzaman);
    }
  },


  CookiesZamanKontrol({ dispatch }, kalanzaman) {
    if(refreshTokenTimer) clearTimeout(refreshTokenTimer);
    refreshTokenTimer = setTimeout(
      function() {
        dispatch("ActionsRefreshToken");
      }.bind(this),
      Math.max(kalanzaman, minRefreshDelayMs)
    );
  } 
};
